import React from 'react';
import { connect } from 'react-redux';

import { limitNumberOfElements } from 'redpoints-front-common/helpers';

import {
  getAuditResultsIsLoading,
  getAuditResultsTotalResults,
} from '../../../reducers/assetAudit/auditResults';
import { translate } from '../../../helpers/languageHelper';

const AuditResultsFiltersTotalResults = ({
  isTotalElementsLoading,
  totalElements,
}) => {
  if (isTotalElementsLoading) {
    return <></>;
  }

  return (
    <>
      {Number.isInteger(totalElements) &&
        `${limitNumberOfElements(totalElements)} ${translate(
          'auditResults.filters.results'
        )}`}
    </>
  );
};

const mapStateToProps = state => ({
  isTotalElementsLoading: getAuditResultsIsLoading(state),
  totalElements: getAuditResultsTotalResults(state),
});

export default connect(mapStateToProps, {})(AuditResultsFiltersTotalResults);
